import * as d3 from 'd3';
import moment from 'moment';
import Axis from './Axis.js';

export default class DayAxis extends Axis {
  constructor(props) {
    super(props);

    this.axis = d3.axisTop(this.xScale).ticks(d3.timeDay.every(1));
  }

  removeText() {
    const { chart } = this.props;

    chart.selectAll('.day .tick text').remove();

    return this;
  }

  setCurrentDay() {
    const { chart } = this.props;

    chart.selectAll('.day .tick text').attr('class', (value) => {
      if (moment(value, 'YYYY-MM-DD').isSame(moment(), 'day')) {
        return 'current-day';
      }
    });

    return this;
  }

  addDayGrid() {
    const {
      chart,
      options: { height, padding },
    } = this.props;
    chart
      .selectAll('.day .tick')
      .select(function (d) {
        return +d3.timeSunday.floor(d) !== +d ? this : null;
      })
      .select('line')
      .transition()
      .duration(0)
      .attr('stroke-dasharray', '3,3')
      .attr('y2', height + padding * 2);

    return this;
  }

  addWeekGrid() {
    const {
      chart,
      options: { height, padding },
    } = this.props;
    chart
      .selectAll('.day .tick')
      // .filter((d, i) => i !== 0)
      .select(function (d) {
        return +d3.timeSunday.floor(d) === +d ? this : null;
      })
      .select('line')
      .transition()
      .duration(0)
      .attr('stroke-dasharray', false)
      .attr('y2', height + padding * 2);

    return this;
  }

  removeDomainPath() {
    const { chart } = this.props;

    chart.select('.day .domain').remove();

    return this;
  }

  update() {
    const { chart } = this.props;

    this.axis.scale(this.xScale);

    chart
      .select('.axis.day')
      .transition()
      .duration(this.transitionDuration)
      .call(this.axis);

    this.removeText()
      .removeDomainPath()
      .setCurrentDay()
      .addDayGrid()
      .addWeekGrid();
  }

  build() {
    const { chart } = this.props;

    chart.append('g').attr('class', 'axis day').call(this.axis);

    this.removeText()
      .removeDomainPath()
      .setCurrentDay()
      .addDayGrid()
      .addWeekGrid();
  }
}
